import {AxiosResponse} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';

export type DeclineType = {
    friendlyMessage: string;
    title: string;
    code: string;
    /** @see https://primer.io/docs/api/api-reference/payments-api/get-payment-by-id#response.body.riskData.fraudChecks.postAuthorizationResult */
    preAuthorizationResult: 'ACCEPT' | 'REFUSE' | 'FAILED' | 'THREE_DS';
};

/**
 * sends request to validate primer order and create order id
 */
export const getPaymentDeclineCode = async (
    id: string,
): Promise<AxiosResponse<DeclineType> | void> => {
    try {
        return await apiConfig.instanceGusaBackend({
            baseURL: apiConfig.API_URL,
            method: 'GET',
            url: ENDPOINTS.PRIMER_DECLINE_REASON({id}),
        });
    } catch (e) {
        return logWithSentry(e, 'Cannot get Primer payment decline reason');
    }
};
